module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-text-0d929877.svg";